<template>
   <van-dialog v-model="show" title="修改联系电话" show-cancel-button @close="onDialogClose" @confirm="onSubmit"
      :beforeClose="onBeforeClose" @open="doQuery">
      <van-form style="min-height: 8rem;">
         <!-- <van-form> -->
         <van-field v-model="formData.CustomerServiceTel" type="tel" name="CustomerServiceTel" label="客服电话" placeholder="请填写客服电话"
            :error-message="customerServiceTelErrorMsg" />
         <van-field v-model="formData.NodeTel" type="tel" name="NodeTel" label="站点电话" placeholder="请填写站点电话"
            :error-message="nodeTelErrorMsg" />
         <van-field v-model="formData.FollowTel" type="tel" name="FollowTel" label="随车人员电话"
            placeholder="请填写随车人员电话" :error-message="followTelErrorMsg" />
         <!-- 跟车员搭配弹出层使用 -->
         <!-- <van-field readonly clickable label="随车人员" :value="CarFollowerNameList" placeholder="请选择随车人员"
            @click="showCarFollowerPicker = true" />
         <van-popup v-model="showCarFollowerPicker" round position="bottom" @open="carFollowerOpen">
            <van-checkbox-group v-model="CarFollowerGIDArr" class="checkbox-group">
               <van-checkbox v-for="(item, index) in carFollowColumns" :key="index" :name="item.DriverGID">{{
                  item.DriverName
               }}</van-checkbox>
            </van-checkbox-group>
            <ul class="flex">
               <li class="w50"><van-button block type="primary" @click="onCarFollowerConfirm">选择</van-button></li>
               <li class="w50"><van-button block type="info" @click="onCarFollowerCancel">取消</van-button></li>
            </ul>
         </van-popup> -->
      </van-form>
   </van-dialog>
</template>

<script>
export default {
   model: {
      prop: 'isShow',
      event: 'change'
   },
   props: {
      isShow: Boolean,
      /**
       * 扩展表单数据
       */
      extendFormData: Object
   },
   data() {
      return {
         show: false,
         formData: {
            FollowTel: '',
            NodeTel: '',
            CarFollowerGIDList: '',
            CustomerServiceTel: ''
         },
         // 错误信息
         followTelErrorMsg: '',
         nodeTelErrorMsg: '',
         customerServiceTelErrorMsg: '',

         CarFollowerGIDArr: [],
         CarFollowerNameList: '', // 仅展示用
         showCarFollowerPicker: false,
         carFollowColumns: [],
         OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      }
   },
   watch: {
      isShow(newVal) {
         this.show = newVal;
      }
   },
   methods: {
      // 取消默认关闭弹框事件
      onBeforeClose(action, done) {
         if (action == 'confirm') {
            return done(false);
         }
         return done(true);
      },
      onDialogClose() {
         this.$emit('change', this.show);
      },
      onSubmit() {
         // 填写了才判断
         if (this.formData.FollowTel && !this.$utils.isPhone(this.formData.FollowTel)) {
            this.followTelErrorMsg = '手机号格式错误';
         } else if (this.formData.NodeTel && !this.$utils.isPhone(this.formData.NodeTel)) {
            this.nodeTelErrorMsg = '手机号格式错误';
         } else if (this.formData.CustomerServiceTel && !this.$utils.isPhone(this.formData.CustomerServiceTel)) {
            this.customerServiceTelErrorMsg = '手机号格式错误';
         } else {
            // this.formData.CarFollowerGIDList = this.CarFollowerGIDArr.toString();
            this.$http.post(this.$api.LineClassDayHandheldSave, {
               _JsonText: JSON.stringify({
                  ...this.extendFormData,
                  ...this.formData,
                  ModifyGID: this.OperObj.GID,
                  ModifyCode: this.OperObj.UserCode,
                  ModifyName: this.OperObj.UserName
               })
            }).then(res => {
               if (res.success) {
                  this.show = false;
               }
            });
         }
      },
      onCarFollowerConfirm(e) {
         console.log(this.CarFollowerGIDArr);
         if (this.CarFollowerGIDArr.length <= 0) {
            this.$dialog.alert({
               title: '警告信息',
               message: '请至少选择一项',
               overlayStyle: {
                  'z-index': 2006
               }
            });
         } else {
            this.CarFollowerNameList = this.CarFollowerGIDArr.map(f => {
               const column = this.carFollowColumns.find(c => c.DriverGID == f);
               return column.DriverName;
            }).toString();
            this.showCarFollowerPicker = false;
         }
      },
      onCarFollowerCancel() {
         this.showCarFollowerPicker = false;
      },
      carFollowerOpen() {
         if (this.carFollowColumns.length <= 0) {
            this.$http.post(this.$api.onCompDriverSimplifyQuery, {
               IsCarFollower: true
            }).then(res => {
               this.carFollowColumns = res.data;
            });
         }
      },
      // 信息查询
      doQuery() {
         this.$http.post(this.$api.LineClassDayHandheldInfoQuery, {
            GID: this.extendFormData.LineClassDayGID,
            StartNodeGID: this.extendFormData.StartNodeGID
         }).then(res => {
            const data = res.data[0];
            if (data) {
               this.formData.FollowTel = data.FollowTel;
               this.formData.NodeTel = data.NodeTel;
               this.formData.CustomerServiceTel = data.CustomerServiceTel;
               // if (data.CarFollowerJson) {
               //    const carFollowerArr = JSON.parse(data.CarFollowerJson);
               //    this.CarFollowerGIDArr = carFollowerArr.map(f => f.CarFollowerGID.toLowerCase());
               //    this.CarFollowerNameList = carFollowerArr.map(f => f.CarFollowerName).toString();
               // } else {
               //    this.CarFollowerNameList = '';
               // }
            }
         });
      }
   }
}
</script>

<style lang="less" scoped>
.checkbox-group {
   margin: .5rem .5rem 0;
   max-height: 6rem;
   overflow: scroll;

   .van-checkbox {
      margin-bottom: .3rem;
   }
}
</style>